/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
/* Dropdown.tsx */
import React, { useState, useRef, useEffect } from 'react';
import styles from '../../styles/components/controlVariations/Dropdown.module.css';
import p1 from '../../assets/profile/Vector (13).png';

export interface DropdownProps {
	placeholder?: string;
	options: string[] | { label: string; value: string; color?: string }[];
	selected?: string;
	onSelect: (value: string) => void;
	width?: string; // existing
	variant?: 'default' | 'filled'; // existing
	disabled?: boolean;

	/* NEW: height for the main control, and menu max height */
	height?: string | number; // e.g. "58px" or 58
	menuMaxHeight?: string | number; // e.g. "240px" or 240
}

const Dropdown: React.FC<DropdownProps> = ({
	placeholder = 'Select',
	options,
	selected,
	onSelect,
	disabled = false,
	width = '',
	variant = 'default',
	height = '58px', // default height for the closed control
	menuMaxHeight = '240px', // default max height for the dropdown list
}) => {
	const [open, setOpen] = useState(false);
	const dropdownRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (disabled) setOpen(false);
		function handleClickOutside(event: MouseEvent) {
			if (
				dropdownRef.current &&
				!dropdownRef.current.contains(event.target as Node)
			) {
				setOpen(false);
			}
		}
		document.addEventListener('mousedown', handleClickOutside);
		return () =>
			document.removeEventListener('mousedown', handleClickOutside);
	}, [disabled]);

	/* Helper: normalize numeric values to px */
	const norm = (v: string | number) => (typeof v === 'number' ? `${v}px` : v);

	return (
		<div
			className={styles.wrapper}
			style={{ width: norm(width) }}
			ref={dropdownRef}
		>
			<div
				className={`${styles.dropdown} ${open ? styles.active : ''} ${
					variant === 'filled' ? styles.filled : ''
				}
          ${disabled ? styles.disabled : ''}
          `}
				onClick={() => {
					if (!disabled) setOpen(!open);
				}}
				style={{ height: norm(height) }}
			>
				<span className={styles.text}>{selected || placeholder}</span>

				<img
					src={p1}
					className={`${styles.icon} ${open ? styles.rotate : ''}`}
					alt="toggle"
				/>
			</div>

			{open && !disabled && (
				<div
					className={styles.menu}
					/* inline style to control menu max height dynamically */
					style={{ maxHeight: norm(menuMaxHeight) }}
				>
					{/* {options.map((opt, i) => (
                        <div
                            key={i}
                            className={styles.menuItem}
                            onClick={() => {
                                onSelect(opt);
                                setOpen(false);
                            }}
                        >
                            {opt}
                        </div>
                    ))} */}
					{options.map((opt, i) => {
						const label = typeof opt === 'string' ? opt : opt.label;
						const value = typeof opt === 'string' ? opt : opt.value;
						return (
							<div
								key={i}
								className={styles.menuItemm}
								onClick={() => {
									onSelect(value);
									setOpen(false);
								}}
							>
								{typeof opt !== 'string' && opt.color && (
									<span
										className={styles.colorDot}
										style={{
											backgroundColor: opt.color,
										}}
									/>
								)}
								{label}
							</div>
						);
					})}
				</div>
			)}
		</div>
	);
};

export default Dropdown;
